import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const DatepickerWrapperDefault: React.FC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const DatepickerWrapper = styled(DatepickerWrapperDefault)`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
`;

export default DatepickerWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/datepicker_wrapper/datepicker_wrapper.tsx